import { ClienteEndereco } from '../model/clienteEndereco';
import { ResultadoSimulacaoPropostaDTO } from './resultadoSimulacaoPropostaDTO';

export class ReemissaoCcbDTO {
  public idProposta?: number;
  public idEmpregador?: number;
  public idOrgao?: number;
  public idFinanciamento?: number;
  public idProduto?: number;
  public nomeCliente?: string;
  public nomeMae?: string;
  public endereco?: ClienteEndereco;
  public valorRMCUtilizado?: number;
  public valorLimite?: number;
  public limiteCompra?: number;
  public limiteSaque?: number;
  public tarifaEmissao?: number;
  public anuidade?: number;
  public simulacaoProposta?: ResultadoSimulacaoPropostaDTO;
  public idFidcConfirmado?: number;
}